import * as React from 'react';
import cn from 'classnames';

import { CheckoutSegmentProps } from '../../types';
import { useTheme } from '../../../theme';
import { format } from '../../../utils';
import { planeIcon } from '../../../BoardingPassDesk/Icons';

interface Props extends CheckoutSegmentProps {
	className?: string;
}

const MobileSegment: React.FC<Props> = ({ className, segment }) => {
	const { MobileSegment: css } = useTheme('RetrieveBooking');

	const fareFamily = segment.fareFamily;
	const firstSegment = segment.segments[0];
	const lastSegment = segment.segments[segment.segments.length - 1];

	return (
		<div className={cn(css.wrapper, className)}>
			<div className={css.fareGroup}>
				<div
					className={css.fareGroup__img}
					style={{
						backgroundImage: `url(${fareFamily?.airline?.icon})`
					}}
				/>

				<div className={css.fareGroup__info}>
					{firstSegment.operatingAirline.iata} {firstSegment.flightNumber},{' '}
					{format(
						firstSegment.departure.date,
						new Date(firstSegment.departure.date).getFullYear() - new Date().getFullYear() < 1
							? 'dd MMMM'
							: 'dd MMM, yyyy'
					)}
				</div>
			</div>

			<div className={css.flightInfo}>
				<div className={css.flightInfo__iatas}>
					<span>{firstSegment.departure.airport.iata}</span>
					<span className={css.planeIcon}>{planeIcon}</span>
					<span>{lastSegment.arrival.airport.iata}</span>
				</div>

				<div className={css.flightInfo__cities}>
					<span>
						{firstSegment.departure.airport.city.name}
						<br />
						{firstSegment.departure.airport.title}
					</span>

					<span>
						{lastSegment.arrival.airport.city.name}
						<br />
						{lastSegment.arrival.airport.title}
					</span>
				</div>

				<div className={css.flightInfo__time}>
					<span>{firstSegment.departure.time.substr(0, 5)}</span>
					<span>{lastSegment.arrival.time.substr(0, 5)}</span>
				</div>
			</div>

			<div className={css.arrivalInfo}></div>
		</div>
	);
};

export default MobileSegment;
